import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmqwrdxtbc: FaireProductEntity = {
  token: "p_hmqwrdxtbc",
  type: "product",
  name: "Chloe Textured Knit Women’s Short Sleeve Cardigan (Organic)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/59c14fc62e24ac5fc756782a85f5846d9a0c0b252a501f59206c48efd07ac94a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68ba2a6a2c2bb4f401c07112467d0fad1952e8867356bd54eef164205bdd6f78.png",
    "https://cdn.faire.com/fastly/eac08d658149cb4794b8c91c9aa6f03433f477356cadfcc7e65069955e62bdb1.png",
  ],
  priceDollars: 44,
  description:
    "A chic spring layer from Viverano’s SS27 collection, the Chloe Cardigan is crafted from certified organic cotton in a soft natural base with refined blue and navy accents. Designed with a flattering V-neckline, button-front closure, and all-over textured knit pattern, it brings an elevated, coastal-inspired feel to everyday dressing.\n\nThe short-sleeve silhouette makes it perfect for warm-weather layering over tanks, dresses, or linen separates, while the breathable organic cotton keeps it soft, comfortable, and effortlessly polished.\n\nCreated to coordinate beautifully with matching Mommy & Me baby styles, this cardigan blends comfort, craftsmanship, and sustainability. Designed in the USA and ethically produced in India, it’s a timeless piece made to be worn, loved, and cherished.",
  tags: [],
  msrpDollars: 88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:31.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
